import React, { useRef, useState } from "react";
import "../kits.css";

import Footer from "..//../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import CardSpotlight from "../../../components/CardSpotlight/CardSpotlight";
import { useNavigate } from "react-router-dom";

const KitMecaAnalogico = () => {
  const continueButtonRef = useRef(null);
  const [editable, setEditable] = useState(false);
  const [cantidadKits, setCantidadKits] = useState(1);
  const [showEditModal, setShowEditModal] = useState(false);

  // Se agregan precios a cada componente para que, si todos están seleccionados, sumen 5000 colones.
  const componentes = {
    "Diodo de germanio": {
      image: "/images/Kits/germanio.jpg",
      description:
        "Este dispositivo semiconductor permite el paso de la corriente en una única dirección.\n" +
        "Cuenta con una tensión de umbral de 0.3V",
      price: 300,
    },
    "Diodo zener": {
      image: "/images/Kits/zener.jpg",
      description:
        "Los diodos zener, a diferencia de los diodos convencionales pueden conducir la corriente al ser polarizados inversamente",
      price: 300,
    },
    "5 diodos de silicio": {
      image: "/images/Kits/diodo.jpg",
      description:
        "El 1N4004 es un diodo rectificador de propósito general, conocido por su fiabilidad y robustez en aplicaciones de manejo de corriente.",
      price: 750,
    },
    "6 capacitores de poliester": {
      image: "/images/Kits/capacitor.jpg",
      description: "3 de cada valor: 100nF, 220nF",
      price: 900,
    },
    "3 capacitores electroliticos": {
      image: "/images/Kits/capacitorel.jpg",
      description: "3 de cada valor 10uF",
      price: 450,
    },
    "20 resistencias": {
      image: "/images/Kits/resistencia.jpg",
      description: "5 de cada valor: 10, 510, 2.2k, 4.7k",
      price: 2000,
    },
    "5 leds": {
      image: "/images/Kits/leds.jpg",
      description: "Luz LED de 5mm ideal para su uso en protoboard",
      price: 1000,
    },
    "Transistor MOSFET": {
      image: "/images/Kits/mosfet.jpg",
      description:
        "Modelo IRF540.  es un transistor de efecto de campo de canal N ",
      price: 600,
    },
    "2 Transistores BJT": {
      image: "/images/Kits/transistor.jpg",
      description: "Modelo: 2N2222. Transistor BJT de propósito general NPN",
      price: 400,
    },
    "1 Amplificador operacional": {
      image: "/images/Kits/741.jpg",
      description: "Modelo LM741",
      price: 700,
    },
  };

  // Extras (en este caso, solo se almacena la imagen)
  const extras = {
    "Caja de herramientas": "/images/Kits/caja.png",
    "Kit de puentes": "/images/Kits/puentes.png",
    Multimetro: "/images/Kits/multimetro.png",
    "3 metros de Cable": "/images/Kits/cable2.png",
  };

  // Precios para los extras
  const extrasPrices = {
    "Caja de herramientas": 2500,
    "Kit de puentes": 2000,
    Multimetro: 10000,
    "3 metros de Cable": 1200,
  };

  // Renderiza extras (se usa el objeto extrasPrices)
  const renderExtras = (items) => {
    return Object.keys(items).map((component, index) => (
      <CardSpotlight
        key={index}
        className="extra-item"
        onClick={() => toggleComponent(component)}
      >
        <p className="extra-name">{component}</p>
        <p className="extra-price">₡{extrasPrices[component]}</p>
        <img src={items[component]} alt={component} className="extra-image" />
        <input
          type="checkbox"
          checked={selectedComponents[component]}
          onChange={() => toggleComponent(component)}
          onClick={(e) => e.stopPropagation()}
        />
      </CardSpotlight>
    ));
  };

  // Estado que gestiona qué componentes y extras están seleccionados
  const [selectedComponents, setSelectedComponents] = useState({
    ...Object.keys(componentes).reduce(
      (acc, key) => ({ ...acc, [key]: true }),
      {}
    ),
    ...Object.keys(extras).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
  });

  // Función para alternar selección de cada componente/extra
  const toggleComponent = (name) => {
    setSelectedComponents((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Calcula el precio sumando los precios de los componentes y extras seleccionados,
  // y lo multiplica por la cantidad de kits.
  const calculatePrice = () => {
    // Verifica si todos los componentes (excluyendo los extras) están seleccionados
    const allComponentsSelected = Object.keys(componentes).every(
      (key) => selectedComponents[key]
    );

    // Si todos los componentes están seleccionados, usamos el precio descontado; de lo contrario, sumamos normalmente.
    let priceComponents = allComponentsSelected
      ? 5000
      : Object.keys(componentes).reduce(
          (sum, key) =>
            selectedComponents[key] ? sum + componentes[key].price : sum,
          0
        );

    // Sumamos los extras normalmente (si están seleccionados)
    let priceExtras = Object.keys(extras).reduce(
      (sum, key) => (selectedComponents[key] ? sum + extrasPrices[key] : sum),
      0
    );

    // Retornamos el total multiplicado por la cantidad de kits
    return (priceComponents + priceExtras) * cantidadKits;
  };

  // Función para el botón de “Editar/Guardar”
  const handleEditClick = () => {
    console.log("handleEditClick:", { editable, showEditModal });
    if (!editable) {
      setShowEditModal(true);
    } else {
      setEditable(false);
    }
  };

  const handleModalAccept = () => {
    console.log("Modal aceptado");
    setEditable(true);
    setShowEditModal(false);
  };

  // Función para reservar (puedes mantenerla o modificarla según necesidades)
  const handleReserve = () => {
    if (continueButtonRef.current) {
      continueButtonRef.current.scrollIntoView({ behavior: "smooth" });
    }
    console.log("Reservar:", { selectedComponents, cantidadKits });
  };

  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/kits/checkout", {
      state: {
        price: calculatePrice(),
        nombre: "Kit de Electronica Analogica",
        selectedComponents,
        cantidadKits,
      },
    });
  };

  // Renderiza los componentes (de la misma forma que antes)
  const renderComponents = (items, isEditable) => {
    return Object.keys(items).map((component, index) => (
      <CardSpotlight key={index} className="component-item">
        <div className="component-content">
          <img
            src={items[component].image}
            alt={component}
            className="component-image"
          />
          <div className="component-description">
            {items[component].description}
          </div>
        </div>
        <div className="component-bottom">
          <p className="component-name">{component}</p>
          {editable && (
            <input
              type="checkbox"
              checked={selectedComponents[component]}
              onChange={() => toggleComponent(component)}
            />
          )}
        </div>
      </CardSpotlight>
    ));
  };

  return (
    <div className="kit-container">
      <Header />

      <div className="kit-content">
        <div className="kit-header">
          <img
            src="/images/Analogica.png"
            alt="Kit de Circuitos"
            className="kit-image"
          />
          <div className="kit-info">
            <h1>Kit de Electrónica Analógica</h1>
            <h3>
              Este kit ha sido rediseñado, contiene aquellos componentes que son
              nuevos para el curso; para que pueda ser complementado con los
              componentes que ya tienes de cursos anteriores. Está especialmente
              pensado para el curso: Laboratorio de Electrónica Analógica MT3002
              de Ingeniería Mecatrónica del Tecnológico de Costa Rica
            </h3>
          </div>
        </div>

        {/* <div className="kits-buttons">
          <button onClick={handleReserve}>Reservar</button>
        </div> */}

        <div className="kits-buttons">
          <button onClick={handleEditClick}>
            {editable ? "Guardar" : "Editar"}
          </button>
        </div>

        <h2>Componentes del Kit</h2>
        <div className="components-grid">
          {renderComponents(componentes, editable)}
        </div>

        <h2>Extras disponibles</h2>
        <div className="extras-grid">{renderExtras(extras)}</div>

        {/* Precio dinámico calculado según los componentes extras y cantidad de kits */}
        <h2>Precio: ₡{calculatePrice()} colones</h2>

        <div className="kits-quantity">
          <label>
            Cantidad de kits:
            <input
              type="number"
              min="1"
              value={cantidadKits}
              onChange={(e) => setCantidadKits(parseInt(e.target.value))}
            />
          </label>
        </div>

        <div className="kits-buttons">
          <button ref={continueButtonRef} onClick={handleContinue}>
            Continuar
          </button>
        </div>
      </div>

      <Footer />

      {/* Ventana modal para confirmar la acción de editar */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <p> A continuación, puede editar su kit quitando componentes</p>
            <p>
              ATENCIÓN: Al eliminar cualquier componente de su kit se renuncia a
              un descuento especial.
            </p>
            <p>
              En caso de pedir múltiples kits, las modificaciones alterarán a
              todos los kits. Si esto no se desea, realice múltiples órdenes
            </p>
            <div className="kits-buttons">
              <button onClick={handleModalAccept}>Aceptar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KitMecaAnalogico;
